import baseHttpService from "core/http/singleton/base";
import { ListResearchReport, ListResearchReportRes, ResearchReportDetailRes, ResearchReportTab } from "./resTypes";
import { getResearchReportTabsUrl, getListReseachReportUrl, getDetailReseachReportUrl } from "./urls";
import { GetListResearchReportParams } from "./paramsTypes";

export const getReseachReportTabsApi = async (
): Promise<ResearchReportTab[]> => {

  const res = await baseHttpService.get<ResearchReportTab[]>(
    getResearchReportTabsUrl
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListReseachReportApi = async (params: GetListResearchReportParams
): Promise<ListResearchReport[]> => {
  const res = await baseHttpService.get<ListResearchReportRes>(
    getListReseachReportUrl,
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data.data;
};


export const getDetailReseachReportApi = async (nodeId: string): Promise<ResearchReportDetailRes> => {
  const res = await baseHttpService.get<ResearchReportDetailRes>(
    getDetailReseachReportUrl(nodeId),
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

